import { countryData } from "@/dashboard-api-types/models/countryData.types";

const getForm = (countryOptions?: countryData[]) => ({
  formId: "country-form",
  formField: {
    country: {
      name: "locCode",
      label: "Country",
      options: [
        ...(Array.isArray(countryOptions) ? countryOptions : []).map(
          ({ country_LocCode, country_LocName }) => ({
            value: country_LocCode,
            label: country_LocName,
          })
        ),
      ],
      errorMsg: "Required",
      errorMinMaxMsg: "",
    },
    year: {
      name: "year",
      label: "Year",
      options: Array.from({ length: 2049 - 1899 }, (_, i) => {
        const year = 1900 + i;
        return { value: year, label: year.toString() };
      }).reverse(),
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 1900 and 2049",
    },
    ageIntervalStart1: {
      name: "ageIntervalStart1",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 200",
    },
    ageIntervalStart2: {
      name: "ageIntervalStart2",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 200",
    },
    ageIntervalStart3: {
      name: "ageIntervalStart3",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 200",
    },
    ageIntervalStart4: {
      name: "ageIntervalStart4",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 200",
    },

    ageIntervalMid1: {
      name: "ageIntervalMid1",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 200",
    },
    ageIntervalMid2: {
      name: "ageIntervalMid2",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 200",
    },
    ageIntervalMid3: {
      name: "ageIntervalMid3",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 200",
    },
    ageIntervalMid4: {
      name: "ageIntervalMid4",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 200",
    },

    survivalLastYearAge1: {
      name: "survivalLastYearAge1",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 1",
    },
    survivalLastYearAge2: {
      name: "survivalLastYearAge2",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 1",
    },
    survivalLastYearAge3: {
      name: "survivalLastYearAge3",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 1",
    },
    survivalLastYearAge4: {
      name: "survivalLastYearAge4",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 1",
    },

    incidenceScalingAge1: {
      name: "incidenceScalingAge1",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 10",
    },
    incidenceScalingAge2: {
      name: "incidenceScalingAge2",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 10",
    },
    incidenceScalingAge3: {
      name: "incidenceScalingAge3",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 10",
    },
    incidenceScalingAge4: {
      name: "incidenceScalingAge4",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 10",
    },

    incidenceRateFirstYear: {
      name: "incidenceRateFirstYear",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 100",
    },
    incidenceRateLastYear: {
      name: "incidenceRateLastYear",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 100",
    },

    startYearInsulin: {
      name: "startYearInsulin",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 1900 and 2048",
    },

    lifeExpectancy: {
      name: "lifeExpectancy",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 100",
    },

    incidenceRateScaling: {
      name: "incidenceRateScaling",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 200000",
    },

    cumulativesSurvAge1: {
      name: "cumulativesSurvAge1",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 1",
    },

    cumulativesSurvAge2: {
      name: "cumulativesSurvAge2",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 1",
    },

    cumulativesSurvAge3: {
      name: "cumulativesSurvAge3",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 1",
    },

    cumulativesSurvAge4: {
      name: "cumulativesSurvAge4",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 1",
    },

    cumulativesInc: {
      name: "cumulativesInc",
      type: "number",
      errorMsg: "Required",
      errorMinMaxMsg: "Only between 0 and 1",
    },
  },
});

export default getForm;
